import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const ReliabilityProcessPayloadSchema = z.object({
    reliability: z.number().optional(),
});

export class ReliabilityProcessPayload extends FromSchema(ReliabilityProcessPayloadSchema) {
    reliability?: number;
}
